
          import p from "/home/nathan/goalert/web/src/app/public/logos/white/goalert-logo-white-scaled@2.webp"
          const prefixPath = pathPrefix + "/static/" + p
          export default prefixPath
        